<div ng-controller="assistantOverviewController as ctrl">
    <c-auto-form config="ctrl.autoFormConfig" class="modal-view assistant"></c-auto-form>
</div>